import dynamic from "next/dynamic"
import { Container } from "@octopus-energy/coral/atoms"
import { type SbBlokData, storyblokEditable } from "@storyblok/react"
import { type SbBlokAnimation } from "../../types"

const Lottie = dynamic(() => import("react-lottie-player"), { ssr: false })

interface DynamicAnimationProps {
    blok: SbBlokAnimation
}

export function DynamicAnimation({ blok }: DynamicAnimationProps) {
    return (
        <Container
            width={blok.width && `${parseInt(blok.width, 10)}px`}
            height={blok.height && `${parseInt(blok.height, 10)}px`}
            attributes={{
                role: "presentation",
                "aria-label": blok.animation.alt,
                ...storyblokEditable(blok as SbBlokData),
            }}
        >
            <Lottie
                loop={blok.loop}
                play
                path={blok.animation.filename}
            />
        </Container>
    )
}
